import { render, staticRenderFns } from "./AssessmentCompleteStep.vue?vue&type=template&id=f23a3e30"
import script from "./AssessmentCompleteStep.vue?vue&type=script&lang=ts"
export * from "./AssessmentCompleteStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports